import React from "react";
import { DetailsTable } from "@/components/ShowcaseDemandCheck";
import "./DemandSheet.scss";

const dateOf = (value) =>
  new Date(value || Date.now()).toLocaleDateString("en-US", { month: "long", day: "numeric", year: "numeric" });

const phoneOf = (digits) => {
  const value = String(digits || "").replace(/\D/g, "");
  return value.length === 10 ? `(${value.slice(0, 3)}) ${value.slice(3, 6)}-${value.slice(6)}` : value;
};

export const AgentCard = ({ agent }) =>
  agent?.name ? (
    <div className="demand-sheet__agent">
      {agent.photoUrl ? <img src={agent.photoUrl} alt="" /> : null}
      <span className="demand-sheet__agent-text">
        <b>{agent.name}</b>
        {[agent.brokerage, phoneOf(agent.phone), agent.email].filter(Boolean).join(" · ")}
      </span>
      <span className="demand-sheet__agent-actions">
        {agent.phone ? <a href={`tel:${String(agent.phone).replace(/\D/g, "")}`}>Call</a> : null}
        {agent.email ? <a href={`mailto:${agent.email}`}>Email</a> : null}
      </span>
    </div>
  ) : null;

const DemandSheet = ({ title, countLine, demand, howWeCount, agent, branding, generatedAt, children }) => (
  <article className="demand-sheet" style={branding?.brandColor ? { "--demand-accent": branding.brandColor } : undefined}>
    <header className="demand-sheet__head">
      {branding?.logoUrl ? <img className="demand-sheet__logo" src={branding.logoUrl} alt={branding.name || ""} /> : null}
      <span className="demand-sheet__date">{dateOf(generatedAt)}</span>
    </header>
    <h1 className="demand-sheet__title">{title}</h1>
    <p className="demand-sheet__count">
      {countLine}: <strong>{demand?.range || "0"}</strong>
    </p>
    {demand?.priceRanges?.length || demand?.timing?.length ? (
      <DetailsTable priceRanges={demand.priceRanges} timing={demand.timing} />
    ) : (
      <p className="demand-sheet__note">No Buyer Want&#8209;Listings fit right now. New ones appear as local agents post&nbsp;them.</p>
    )}
    <p className="demand-sheet__note">{howWeCount}</p>
    <AgentCard agent={agent} />
    {children}
  </article>
);

export default DemandSheet;
